import React from "react"
import { graphql } from "gatsby"
import { inlineRemarkForm } from "gatsby-tinacms-remark"
import Layout from "../components/layout"
import SEO from "../components/seo"

function blogPostTemplate({ location, data }) {
  const { markdownRemark: post } = data
  return (
    <Layout>
      <SEO title={post.frontmatter.title} />
      <div className="container py-5">
        <div className="blog-post-container">
          <div className="blog-post">
            <h2>{post.frontmatter.title}</h2>
            <div className="blog-post-date mt-3">
              {/* <span className="text-muted">
                {moment(post.frontmatter.date).format("LL")}
              </span> */}
            </div>
            <div
              className="blog-post-content mt-4"
              dangerouslySetInnerHTML={{ __html: post.html }}
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        slug
      }
      # Tina uses additional, specialized query data.
      # Add the required data using this GraphQL fragment.
      ...TinaRemark
    }
  }
`

// Pass in the component to wrap and configuration object
export default inlineRemarkForm(blogPostTemplate, {
  queryName: "markdownRemark",
})
